// 'use server'
import { getImpactSimulation } from '@services/mcube';

import { getServerSession } from '@actions/get-session';

export const getImpactSimulationServer = async (gencodes: string[]) => {
    const user = await getServerSession();
    if (user) {
        return getImpactSimulation(user, gencodes);
    }

    return null;
};
